import dayjs from 'dayjs';
import axiosInstance from '../axiosConfig';
import { Token } from '../components/EditToken';

const API_URL = '/api/partners';

export interface Partner {
    id?: string;
    name: string;
    email: string;
    telephone: string;
    numberOfTokens: number;
}

export interface PartnerWithTransactions extends Partner {
    transactionMessages: TransactionMessage[];
    fragments: Record<string, string>;
}

export interface TransactionMessage {
    message: string;
    tokenId: string;
    number: number;
    createdDateTime?: string | Date;
}

export const PartnerService = {
    async fetchPartners(): Promise<Partner[]> {
        const response = await axiosInstance.get<Partner[]>(API_URL);
        return response.data;
    },
    async createPartner(partner: Partner): Promise<Partner> {
        const response = await axiosInstance.post<Partner>(API_URL, partner);
        return response.data;
    },
    async editPartner(id: string, partner: Partner): Promise<Partner> {
        const response = await axiosInstance.put<Partner>(`${API_URL}/${id}`, partner);
        return response.data;
    },
    async createTokenForPartner(partnerId: string, token: Token): Promise<Token> {
        const response = await axiosInstance.post<Token>(`${API_URL}/${partnerId}/newToken`, token);
        return response.data;
    },
    async getPartnerById(id: string): Promise<PartnerWithTransactions> {
        const response = await axiosInstance.get<PartnerWithTransactions>(`${API_URL}/${id}`);

        if (response.data.transactionMessages) {
            response.data.transactionMessages.forEach((message) => {
                message.createdDateTime = dayjs(message.createdDateTime).toDate();
            });
        }

        return response.data;
    },
    async addTransactionMessage(partnerId: string, transactionMessage: TransactionMessage): Promise<TransactionMessage> {
        const response = await axiosInstance.post<TransactionMessage>(
            `${API_URL}/${partnerId}/transactions`,
            transactionMessage
        );
        return response.data;
    }
};
